export default __webpack_public_path__ + "static/australian-curriculum-1ff57eb913cf171934c1db67c589df88.svg";